import { channels } from "@/mocks/guaData";

export default function ChannelSection() {
  return (
    <section id="channels" className="scroll-mt-24 w-full bg-background-100/70">
      <div className="mx-auto w-full max-w-[1200px] px-4 md:px-6 py-16 md:py-20">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-4">
          <div className="max-w-xl">
            <span className="inline-flex items-center gap-2 rounded-full bg-secondary-100 px-4 py-1.5 text-xs font-semibold text-secondary-800">
              <i className="ri-layout-grid-line"></i> 栏目分类
            </span>
            <h2 className="font-heading mt-5 text-3xl md:text-4xl font-bold text-foreground-950">按圈层找瓜，更快进入状态</h2>
            <p className="mt-4 text-base text-foreground-600 leading-relaxed">无论你想看哪个圈层的事件，都有专门栏目把来龙去脉一次整理清楚。</p>
          </div>
          <button className="whitespace-nowrap cursor-pointer inline-flex items-center gap-2 rounded-full bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 hover:bg-primary-600 w-fit">
            探索全部栏目 <i className="ri-arrow-right-line"></i>
          </button>
        </div>

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {channels.map((c) => (
            <article
              key={c.id}
              className="group cursor-pointer rounded-2xl border border-background-200 bg-background-50 p-6 transition-colors hover:border-primary-200 hover:bg-background-50"
            >
              <div className="flex items-center justify-between">
                <span className="flex h-12 w-12 items-center justify-center rounded-2xl bg-primary-100 text-primary-600 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
                  <i className={`${c.icon} text-2xl`}></i>
                </span>
                <span className="text-xs text-foreground-400">{c.count}</span>
              </div>
              <h3 className="mt-5 font-heading text-lg font-bold text-foreground-950">{c.name}</h3>
              <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{c.desc}</p>
              <span className="mt-4 inline-flex items-center gap-1 text-sm font-medium text-primary-600">
                进入栏目 <i className="ri-arrow-right-line text-base"></i>
              </span>
            </article>
          ))}
        </div>

        <div className="mt-10 rounded-3xl border border-background-200 bg-background-50 p-6 md:p-8">
          <h3 className="font-heading text-xl font-bold text-foreground-950">看瓜到底怎么看？</h3>
          <p className="mt-2 text-sm text-foreground-600 leading-relaxed max-w-xl">一套简单的四步框架，帮你看懂任何事件的完整脉络。</p>
          <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {[
              { n: "01", t: "抓取节点", d: "找出时间线里的关键节点与各方发声。" },
              { n: "02", t: "还原过程", d: "把碎片信息串成完整的事件经过。" },
              { n: "03", t: "甄别信息", d: "区分已确认事实与网友讨论、推测。" },
              { n: "04", t: "建立判断", d: "基于完整来龙去脉形成自己的看法。" },
            ].map((s) => (
              <div key={s.n} className="flex gap-4 items-start">
                <span className="font-display text-3xl font-bold text-primary-300">{s.n}</span>
                <div>
                  <h4 className="font-heading text-base font-bold text-foreground-950">{s.t}</h4>
                  <p className="mt-1 text-sm text-foreground-600">{s.d}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}